import { SVGProps } from "react";

export function DashboardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3 9.847a3 3 0 011.007-2.242l5.336-4.743a4 4 0 015.315 0l5.335 4.743A3 3 0 0121 9.847V18a4 4 0 01-4 4H7a4 4 0 01-4-4V9.847z"
        opacity="0.4"
      />
      <path fill="currentColor" d="M8 18a4 4 0 018 0v4H8v-4z" />
    </svg>
  );
}
